import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { issueStore } from '@/stores/issue'
import dayjs, { Dayjs } from 'dayjs'
import { IssueStates } from '@/models/IssueModel'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { computed } from 'vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueAppointmentCard',
  setup(__props) {

const dateFormat = 'DD-MM-YYYY HH:mm'
const issue = issueStore().issue

function updateAppointment () : void {
  issueStore().updateIssue(issue)
}

function clearAppointment () : void {
  issue.appointment_at = null
  updateAppointment()
}

function isActiveState (status: number): boolean {
  const closedStates = [IssueStates.Opgelost, IssueStates.Gesloten, IssueStates.Afgewezen]
  return !closedStates.includes(status)
}

function disabledDate (currentDate: Dayjs): boolean {
  return currentDate < dayjs().endOf('day')
}

const canEdit = computed(() => {
  return !!(!authStore().user.roleNames.includes('external_inspector') || (authStore().user.roleNames.includes('external_inspector') && issueStore().issue.created_by.id === authStore().user.id))
})

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Afspraak",
    bordered: false
  }, {
    default: _withCtx(() => [
      (isActiveState(_unref(issue).status) && _unref(canEdit))
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: _unref(issue).appointment_at,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(issue).appointment_at) = $event)),
                    span: 12,
                    format: dateFormat,
                    "value-format": 'YYYY-MM-DDTHH:mm:ss',
                    "disabled-date": disabledDate,
                    "show-time": { format: 'HH:mm', minuteStep: 15 },
                    "allow-clear": false,
                    onOk: updateAppointment,
                    placeholder: "Kies een datum"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: clearAppointment,
                    disabled: !_unref(issue).appointment_at,
                    title: "Afspraak verwijderen"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(DeleteOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
            default: _withCtx(() => [
              (_unref(issue).appointment_at)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    if: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(dayjs)(_unref(issue).appointment_at).format(dateFormat)), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_col, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("Geen afspraak ingepland.")
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})